<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="heading_id_2"><span><a id="page_vii"></a>Contents</span></h2>
<p class="toc-entry1z" id="praise"><span><span href="#/Text/frontmatter#praise" title="Link target outside of Sample">Praise for Grace for the Afflicted</span></span></p>
<p class="toc-entry" id="rpart01"><span><a href="#/Text/part01"><strong>Part I<br/>
  A SPIRITUAL PERSPECTIVE</strong></a></span></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="sgc-1" valign="top">
<p class="toc-entry1" id="rpart01chapter01"><span><a href="#/Text/part01chapter01">Chapter 1</a></span></p>
</td>
<td class="sgc-2" valign="top">
<p class="toc-entry1"><span><a href="#/Text/part01chapter01">Fearfully and Wonderfully Made</a></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry2" id="rpart01chapter02"><span><a href="#/Text/part01chapter02">Chapter 2</a></span></p>
</td>
<td valign="top">
<p class="toc-entry2"><span><a href="#/Text/part01chapter02">The Adversary</a></span></p>
</td>
</tr>
</tbody></table>
<p class="toc-entry" id="rpart02"><span><span href="#/Text/part02" title="Link target outside of Sample"><strong>Part II<br/>
  PSYCHOLOGY, PSYCHIATRY, AND FAITH</strong></span></span></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="sgc-1" valign="top">
<p class="toc-entry1" id="rpart02chapter03"><span><span href="#/Text/part02chapter03" title="Link target outside of Sample">Chapter 3</span></span></p>
</td>
<td class="sgc-2" valign="top">
<p class="toc-entry1"><span><span href="#/Text/part02chapter03" title="Link target outside of Sample">The Secular and the Sacred</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry2" id="rpart02chapter04"><span><span href="#/Text/part02chapter04" title="Link target outside of Sample">Chapter 4</span></span></p>
</td>
<td valign="top">
<p class="toc-entry2"><span><span href="#/Text/part02chapter04" title="Link target outside of Sample">A Cake of Figs</span></span></p>
</td>
</tr>
</tbody></table>
<p class="toc-entry" id="rpart03"><span><span href="#/Text/part03" title="Link target outside of Sample"><strong>Part III<br/>
  WHAT ARE MENTAL DISORDERS?</strong></span></span></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="sgc-1" valign="top">
<p class="toc-entry1" id="rpart03chapter05"><span><span href="#/Text/part03chapter05" title="Link target outside of Sample">Chapter 5</span></span></p>
</td>
<td class="sgc-2" valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter05" title="Link target outside of Sample">Mood Disorders</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rpart03chapter06"><span><span href="#/Text/part03chapter06" title="Link target outside of Sample">Chapter 6</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter06" title="Link target outside of Sample">Anxiety Disorders</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rpart03chapter07"><span><span href="#/Text/part03chapter07" title="Link target outside of Sample">Chapter 7</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter07" title="Link target outside of Sample">Schizophrenia</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rpart03chapter08"><span><span href="#/Text/part03chapter08" title="Link target outside of Sample">Chapter 8</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter08" title="Link target outside of Sample">Dissociative Disorders</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rpart03chapter09"><span><span href="#/Text/part03chapter09" title="Link target outside of Sample">Chapter 9</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter09" title="Link target outside of Sample">Eating Disorders</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rpart03chapter10"><span><span href="#/Text/part03chapter10" title="Link target outside of Sample">Chapter 10</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter10" title="Link target outside of Sample">Attention-Deficit / Hyperactivity Disorder</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rpart03chapter11"><span><span href="#/Text/part03chapter11" title="Link target outside of Sample">Chapter 11</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/part03chapter11" title="Link target outside of Sample">Substance Use Disorders</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry2" id="rpart03chapter12"><span><span href="#/Text/part03chapter12" title="Link target outside of Sample">Chapter 12</span></span></p>
</td>
<td valign="top">
<p class="toc-entry2"><span><span href="#/Text/part03chapter12" title="Link target outside of Sample">Borderline Personality Disorder</span></span></p>
</td>
</tr>
</tbody></table>
<p class="toc-entry" id="rpart04"><span><span href="#/Text/part04" title="Link target outside of Sample"><strong>Part IV<br/>
  HOW CAN WE HELP THOSE WHO STRUGGLE?</strong></span></span></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="sgc-1" valign="top">
<p class="toc-entry1" id="rpart04chapter13"><span><span href="#/Text/part04chapter13" title="Link target outside of Sample">Chapter 13</span></span></p>
</td>
<td class="sgc-2" valign="top">
<p class="toc-entry1"><span><span href="#/Text/part04chapter13" title="Link target outside of Sample">Come to Me</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry2" id="rpart04chapter14"><span><span href="#/Text/part04chapter14" title="Link target outside of Sample">Chapter 14</span></span></p>
</td>
<td valign="top">
<p class="toc-entry2"><span><span href="#/Text/part04chapter14" title="Link target outside of Sample">Little Things Matter</span></span></p>
</td>
</tr>
</tbody></table>
<p class="toc-entry" id="rappendix"><a id="page_viii"></a><span><span href="#/Text/appendix" title="Link target outside of Sample"><strong>Appendix<br/>
  MENTAL HEALTH RESOURCES</strong></span></span></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="sgc-1" valign="top">
<p class="toc-entry1" id="rappendix01"><span><span href="#/Text/appendix01" title="Link target outside of Sample">Appendix 1</span></span></p>
</td>
<td class="sgc-2" valign="top">
<p class="toc-entry1"><span><span href="#/Text/appendix01" title="Link target outside of Sample">National Mental Health Organizations</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rappendix02"><span><span href="#/Text/appendix02" title="Link target outside of Sample">Appendix 2</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/appendix02" title="Link target outside of Sample">Christian Mental Health Counselors, Psychologists, and Physicians</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rappendix03"><span><span href="#/Text/appendix03" title="Link target outside of Sample">Appendix 3</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/appendix03" title="Link target outside of Sample">Christian Mental Health Support Groups, Clinics, and Hospitals</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry1" id="rappendix04"><span><span href="#/Text/appendix04" title="Link target outside of Sample">Appendix 4</span></span></p>
</td>
<td valign="top">
<p class="toc-entry1"><span><span href="#/Text/appendix04" title="Link target outside of Sample">Lay Counselor Training Resources</span></span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="toc-entry2" id="rappendix05"><span><span href="#/Text/appendix05" title="Link target outside of Sample">Appendix 5</span></span></p>
</td>
<td valign="top">
<p class="toc-entry2"><span><span href="#/Text/appendix05" title="Link target outside of Sample">Recommended Reading</span></span></p>
</td>
</tr>
</tbody></table>
<p class="toc-entry1" id="rata"><span><span href="#/Text/ata" title="Link target outside of Sample">About the Author</span></span></p>
<p class="toc-entry" id="bm"><span><span href="#/Text/backmattera#bm" title="Link target outside of Sample">Also Available</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?eb5c0864